import {
  SourceShareEnum,
  sourceShareLocoKeys,
} from 'modules/affiliate-dashboard/enums/source-share-enum'
import React from 'react'
import LinkWithoutPrefetch from 'shared/components/link-without-prefetch'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

interface AffiliateDashboardLeadOptionSourceProps {
  sourceUrl: null | string
  sourceText: null | SourceShareEnum
}

export const AffiliateDashboardLeadOptionSource = ({
  sourceUrl,
  sourceText,
}: AffiliateDashboardLeadOptionSourceProps): JSX.Element | null => {
  const { t } = useLocoTranslation()

  if (sourceUrl) {
    return (
      <LinkWithoutPrefetch className="primary-link truncate text-start" href={sourceUrl}>
        {sourceText ? t(sourceShareLocoKeys[sourceText]) : sourceUrl}
      </LinkWithoutPrefetch>
    )
  }

  if (sourceText) {
    return <span className="truncate text-start">{t(sourceShareLocoKeys[sourceText])}</span>
  } else {
    return null
  }
}
